import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getAdvanced } from '../../utils';
export default (node => {
  var locations = JSON.parse(node.getAttribute('data-locations')).map(location => {
    location.name = location.location_name;
    delete location.location_name;
    location.country = Array.isArray(location.country) ? location.country.join(' ') : location.country;
    return location;
  });
  var isShowControls = node.getAttribute('data-show-controls') === 'true';
  return _objectSpread({
    height: node.style.height,
    locations,
    mapOptions: Object.assign({}, mapDefaultProps.mapOptions, {
      disableDefaultUI: !isShowControls,
      mapTypeControl: isShowControls
    })
  }, getAdvanced(node));
});
export var mapDefaultProps = {
  apiKey: process.env.GOOGLE_MAPS_API_KEY,
  locations: [],
  mapOptions: {
    zoom: 8,
    scrollwheel: false,
    disableDoubleClickZoom: false,
    disableDefaultUI: false,
    mapTypeControl: true
  }
};